<template>
	<div ref="resultsWrapper" class="grid-container full">
		<p v-if="results.length===0">{{ dctxt('noResultsMessage') }}</p>
		<div ref="resultsWrapperInner" class="grid-x grid-margin-x grid-margin-y">
			<div 
				v-for="(result, index) in results" 
				ref="resultsWrapperInnerAlt"
				:key="'result-' + index" 
				:class="['cell', 'small-12', {
					'large-4': (gridLayout === 'default' && result.post_type !== 'dc_faq'),
					'medium-6': (gridLayout === 'default' || (gridLayout==='news' && ![0, 3].includes(index))),

				}]">
				<default 
					v-if="!['dc_company', 'dc_faq', 'dc_person', 'dc_mentor'].includes(result.post_type)" 
					:id="result.id" 
					:title="result.title" 
					:excerpt="result.excerpt" 
					:url="result.url" 
					:image="result.image" 
					:label="result.label" 
					:class="[{
						featured: gridLayout==='news' && [0, 3].includes(index),
						'media-right': (gridLayout==='news' &&  index===0),
					}]"
					:style="{zIndex: results.length - index}"
					/>
			</div>
		</div>	
		<LoadMore 
			v-if="showLoadMore && !endOfResults"
			:currentPaged="currentPaged"
			:totalPages="totalPages"
			:loading="loading" 
			:searchButtonId="searchButtonId"
			v-on:update-current-paged="updateCurrentPaged" />
	</div>
</template>

<script>
import { Translatable } from '@dc-post-grid/mixins/Translatable';
import Default from '@dc-post-grid/layout/cards/Default';
import LoadMore from '@dc-post-grid/layout/ui/LoadMore';
export default {
	mixins: [
		Translatable
	],
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		results: {
			type: Array,
			required: true
		},
		gridLayout: {
			type: String,
			default: 'default',
			required: false
		},
		showLoadMore: {
			type: Boolean,
			default: false,
			required: true
		},
		currentPaged: {
			type: Number,
			required: false
		},
		totalPages: {
			type: Number,
			required: false
		},
		usesPagination: {
			type: Boolean,
			default: false,
		},
		endOfResults: {
			type: Boolean,
			default: false,
			required: true
		},
		searchButtonId: {
			type: String,
			required: true
		}
	},
	methods: {
		updateCurrentPaged(newPagedNumber) {
			this.$emit('update-current-paged', newPagedNumber)
		}
	},
	components: {
		Default,
		LoadMore,
	}
}
</script>